import { Component } from '@angular/core';

import menuButtonStyles from 'vbrick-player-src/MenuButton.module.less';
import { IDualPlaybackLayoutOption } from './IDualPlaybackLayoutOption';
import { PLAYER_USER_PREFERENCE_KEY } from 'vbrick-player-src/shared/userPreference/PlayerUserPreferenceHandler';
import { VbDualPlaybackLayoutMenuButtonComponent } from './VbDualPlaybackLayoutMenuButton.Component';
import { userAgentUtil } from 'vbrick-player-src/UserAgentUtil';

import styles from './VbDualPlaybackLayoutMenuButtonV2.module.less';

@Component({
	selector: 'vb-dual-playback-layout-menu-button-v2',
	host: {
		'[class]': 'styles.root + " " + (isSmallSizePlayer ? styles.smallSizePlayer : "")'
	},
	template: `
		<div
			[ngClass]="styles.dropdown"
			dropdown
			#dropdown="bs-dropdown"
			placement="top right"
			[dropup]="true"
			[insideClick]="true"
			[hidden]="!vgApi.isDualPlayback">

			<button
				[ngClass]="styles.menuButton"
				id="buttonLayoutMenu"
								type="button"
				[tooltip]="translations['dualPlaybackLayoutViews']"
				[placement]="'top'"
				[attr.aria-label]="translations['dualPlaybackLayoutViews']"
				vbControlBarFocus
				dropdownToggle>
			</button>

			<div *dropdownMenu
				#vbDropdownMenu
				tabindex="0"
				id="dropdownLayoutMenu"
				aria-labelledby="buttonLayoutMenu"
				[ngClass]="[
					styles.dropdownMenu,
					userAgentUtil.isIeOrLegacyEdge ? styles.ie : ''
				]">
				<div [ngClass]="styles.optionButtonsWrapper">
					<button
						type="button"
						[ngClass]="styles.optionButton"
						(click)="updateToContentOnlyLayout()"
						[attr.aria-label]="translations.fullViewContent">
						<span class="vb-icon vb-icon-content-only"></span>
					</button>
					<button
						type="button"
						[ngClass]="styles.optionButton"
						(click)="updateToSpeakerOnlyLayout()"
						[attr.aria-label]="translations.fullViewSpeaker">
						<span class="vb-icon vb-icon-speaker"></span>
					</button>
				</div>
				<ul [ngClass]="styles.layoutOptionsWrapper"
					role="menu">
					<li tabindex="0" role="menuitem" *ngFor="let layoutOption of layoutOptions; trackBy: layoutOptionsTrackByFunc"
						[ngClass]="[
							styles.layoutOption,
							layoutOption.id === vgApi.dualPlaybackLayout.id ? styles.active : ''
						]"
						[attr.aria-label]="translations[layoutOption.id]"
						(keyup)="onKeyupEvent($event, layoutOption)"
						(click)="updateSelection(layoutOption)">
					</li>
				</ul>
			</div>
		</div>`,
    standalone: false
})
export class VbDualPlaybackLayoutMenuButtonV2Component extends VbDualPlaybackLayoutMenuButtonComponent {
	public readonly userAgentUtil = userAgentUtil;
	public readonly styles = { ...menuButtonStyles, ...styles };

	protected resetSelection(): void {
		if (this.layoutOptions?.length) {
			const userPreferenceLayout = this.PlayerUserPreferencesService.getPreference<IDualPlaybackLayoutOption>(PLAYER_USER_PREFERENCE_KEY.DUAL_PLAYBACK);
			const defaultOption = userPreferenceLayout || this.layoutOptions.find(option => option.isDefault) || this.layoutOptions[0];
			super.updateSelection(defaultOption);
		}
	}

	public updateToContentOnlyLayout(): void {
		this.updateSelection(this.layoutOptions.find(option => option.isContentOnly));
	}

	public updateToSpeakerOnlyLayout(): void {
		this.updateSelection(this.layoutOptions.find(option => option.isSpeakerOnly));
	}

	/**
	 * TODO - Add anchor tag inside li tag and move click event to it.
	 * Having a click event on li tag not semantically correct.
	 */
	public onKeyupEvent(event: KeyboardEvent, layoutOption: IDualPlaybackLayoutOption) {
		const target = event.target as HTMLElement;

		if (target.tagName === 'LI' && event.key === 'Enter') {
			this.updateSelection(layoutOption);
		}
	}

	public updateSelection(layoutOption: IDualPlaybackLayoutOption): void {
		super.updateSelection(layoutOption);
		this.PlayerUserPreferencesService.setPreference(PLAYER_USER_PREFERENCE_KEY.DUAL_PLAYBACK, layoutOption);
	}
}
